import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Filter, FilterTemplate } from '@models/filter-types';
import { getFilters } from '@shared/helpers/functions/filter-helpers';

@Component({
    selector: 'app-add-segment-popup-filter-row',
    templateUrl: './add-segment-popup-filter-row.component.html',
    styleUrls: ['./add-segment-popup-filter-row.component.scss'],
    standalone: false,
})
export class AddSegmentPopupFilterRowComponent implements OnInit, OnChanges {
    @Input() template!: FilterTemplate;
    @Input() dynamicFilters!: { [filterName: string]: Filter<unknown> };
    @Input() name = '';
    @Input() isFiltering = false;
    @Input() isRecurring? = false;

    properties: unknown;
    dynamicProperties!: Filter<unknown>[];

    isLoaded = false;

    constructor() {}

    ngOnInit(): void {
        getFilters(this.template).subscribe((filters) => {
            this.properties = filters;
            this.properties = Object.keys(filters)
                .filter((k) => filters[k as keyof FilterTemplate] instanceof Filter)
                .map((k) => filters[k as keyof FilterTemplate]);
            this.isLoaded = true;
        });
    }

    ngOnChanges() {
        if (this.dynamicFilters) {
            this.dynamicProperties = Object.keys(this.dynamicFilters)
                .filter((k) => this.dynamicFilters[k] instanceof Filter)
                .map((k) => this.dynamicFilters[k]);
        }
    }
}
